import axios from 'axios';

export default {
  state: {
    boutiques: {},
    loading: false,
    error: null,
    boutiquesLoaded: false
  },
  mutations: {
    SET_BOUTIQUES(state, product) {
      state.boutiques = product;
      state.boutiquesLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_BOUTIQUES_LOADING(state, status) {
      state.boutiquesLoading = status;
    },
    SET_BOUTIQUES_ERROR(state, error) {
      state.boutiquesError = error;
    },
    UNSET_BOUTIQUES(state) {
      state.boutiquesLoaded = false;
      state.boutiquesLoading = false;
      state.boutiques = [];
    },
  },
  actions: {
    async fetchBoutique({ commit, state }) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_BOUTIQUES_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/boutique/');
        commit('SET_BOUTIQUES', response.data.data);
        commit('SET_BOUTIQUES_ERROR', null);
      } catch (error) {
        commit('SET_BOUTIQUES_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_BOUTIQUES_LOADING', false);
      }
    }
  },
  getters: {
    boutiques: state => state.boutiques,
    boutiquesLoading: state => state.boutiquesLoading,
    boutiquesError: state => state.boutiquesError,
    boutiquesLoaded: state => state.boutiquesLoaded
  }
}